export default __webpack_public_path__ + "static/media/banner3.0cf7fa4c.jpg";